import { Box, Center, Text } from "@mantine/core";
import type { ComponentType } from "react";
import {
  IconBridge,
  IconBridgeOnImplant,
  IconCompleteDenture,
  IconCrown,
  IconCrownOnImplant,
  IconCrownOnInlayCore,
  IconCustomTray,
  IconDigitalDesign,
  IconInlayCore,
  IconInlayOnlay,
  IconPartialDenture,
  IconRetentionWire,
  IconSpaceMaintainer,
  IconSplintedCrown,
  IconBruxismSplint,
  IconVeneer,
  IconWaxBite,
} from "./icons";

const ICON_BY_PRODUCT_TYPE: Record<string, ComponentType<{ size?: number }>> = {
  CROWN: IconCrown,
  SPLINTED_CROWN: IconSplintedCrown,
  LAY: IconInlayOnlay,
  VENEER: IconVeneer,
  BRIDGE: IconBridge,
  INLAY_CORE: IconInlayCore,
  CROWN_ON_INLAY_CORE: IconCrownOnInlayCore,
  IMPLANT_CROWN: IconCrownOnImplant,
  SPLINTED_CROWN_IMPLANT: IconCrownOnImplant,
  BRIDGE_IMPLANT: IconBridgeOnImplant,
  PARTIAL_DENTURE: IconPartialDenture,
  FULL_DENTURE: IconCompleteDenture,
  SPLINT: IconBruxismSplint,
  SPACE_MAINTAINER: IconSpaceMaintainer,
  RETENTION_WIRE: IconRetentionWire,
  CUSTOM_TRAY: IconCustomTray,
  WAX_BITE: IconWaxBite,
  SCAN_ONLY: IconDigitalDesign,
};

const ICON_SIZE = 38;

export const ProductIcon = ({
  productTypes,
  isRemovable = false,
}: {
  productTypes: string[];
  isRemovable?: boolean;
}) => {
  if (productTypes.length > 1) {
    return (
      <Center
        w={ICON_SIZE}
        h={ICON_SIZE}
        bg="violet.0"
        c="brand.5"
        pos="relative"
        style={{ borderRadius: "var(--mantine-radius-sm)" }}
      >
        <Text ff="monospace" fz={13} fw={700} c="brand.5">
          {productTypes.length}
        </Text>
        <Box
          pos="absolute"
          right={-3}
          bottom={-3}
          w={14}
          h={14}
          bg="violet.1"
          style={{
            borderRadius: 4,
            border: "2px solid var(--mantine-color-cardBackground-0)",
          }}
        />
      </Center>
    );
  }

  const Icon = ICON_BY_PRODUCT_TYPE[productTypes[0] ?? ""] ?? IconDigitalDesign;

  return (
    <Center
      w={ICON_SIZE}
      h={ICON_SIZE}
      bg={isRemovable ? "emerald.0" : "brand.0"}
      c={isRemovable ? "emerald.6" : "brand.5"}
      style={{ borderRadius: "var(--mantine-radius-sm)" }}
    >
      <Icon size={22} />
    </Center>
  );
};
